function getDaysTimes (dayTime) {
  let temp = dayTime.split(';')
  let arr = []
  for (let i = 0; i < temp.length; i++) {
    let [ days, times ] = temp[i].split(' ')
    let [ start, end ] = times.split('-')
    arr.push({ days, start, end })
  }
  return arr
}

function timesOverlap (startA, endA, startB, endB) {
  return parseInt(startA) <= parseInt(endB) && parseInt(endA) >= parseInt(startB)
}

exports.hasOverlap = function (a, b) {
  if (a.day_time == null || b.day_time == null) return false
  const daysTimesA = getDaysTimes(a.day_time)
  const daysTimesB = getDaysTimes(b.day_time)
  for (let i = 0; i < daysTimesA.length; i++) {
    for (let j = 0; j < daysTimesB.length; j++) {
      for (let k = 0; k < daysTimesA[i].days.length; k++) {
        if (daysTimesB[j].days.search(daysTimesA[i].days[k]) >= 0) {
          if (timesOverlap(daysTimesA[i].start, daysTimesA[i].end, daysTimesB[j].start, daysTimesB[j].end)) return true
        }
      }
    }
  }
  return false
}

exports.getDaysTimes = getDaysTimes
exports.timesOverlap = timesOverlap
